!(function ($) {
  // ----------------------------//
  // Add custom JavasScript here //
  // ----------------------------//

  // Document ready
  $(function () {
    $(".option-selector").change(function () {
      if ($(this).closest("form").find(":submit").hasClass("disabled")) {
        $("#priceper").hide();
        $("#priceperhank").hide();
      } else {
        location.reload();
      }
    });
  });

  $("#casingType").change(function () {
    switch (this.value) {
      case "hog":
        $("#hog_sizeCalc").show();
        $("#sheep_sizeCalc").hide();
        $("#beef_sizeCalc").hide();
        $("#collagen_sizeCalc").hide();
        $("#fibrous_sizeCalc").hide();
        break;
      case "sheep":
        $("#hog_sizeCalc").hide();
        $("#sheep_sizeCalc").show();
        $("#beef_sizeCalc").hide();
        $("#collagen_sizeCalc").hide();
        $("#fibrous_sizeCalc").hide();
        break;
      case "beef":
        $("#hog_sizeCalc").hide();
        $("#sheep_sizeCalc").hide();
        $("#beef_sizeCalc").show();
        $("#collagen_sizeCalc").hide();
        $("#fibrous_sizeCalc").hide();
        break;
      case "collagen":
        $("#hog_sizeCalc").hide();
        $("#sheep_sizeCalc").hide();
        $("#beef_sizeCalc").hide();
        $("#collagen_sizeCalc").show();
        $("#fibrous_sizeCalc").hide();
        break;
      case "fibrous":
        $("#hog_sizeCalc").hide();
        $("#sheep_sizeCalc").hide();
        $("#beef_sizeCalc").hide();
        $("#collagen_sizeCalc").hide();
        $("#fibrous_sizeCalc").show();
        break;
    }
  });

  //----------------------------------------
  //--- Hog Recommendations
  //----------------------------------------
  $("#hog_sizeCalc").submit(function () {
    //-- calculate
    linkLength = $("#hog_length").val();
    linksPerPound = $("#hog_linksperlb").val();
    x = linkLength * linksPerPound;
    a = 25800 / x;
    targetCaseSize = Math.round(Math.sqrt(a));
    console.log(
      "linkLenght: " +
        linkLength +
        ", linksPerPound: " +
        linksPerPound +
        ", x: " +
        x +
        ", a: " +
        a +
        ", targetCaseSize: " +
        targetCaseSize
    );
    var recommendation = "none.";
    var alternative = "none.";
    //-- find in the arrays
    recommendation = $.map(hogArray, function (n) {
      return targetCaseSize == n.size ? n.recommendation : null;
    });
    alternative = $.map(hogArray, function (n) {
      return targetCaseSize == n.size ? n.alternative : null;
    });
    //-- display
    $("#recommendation").html(
      recommendation.length === 0 ? "none." : recommendation
    );
    $("#alternative").html(alternative.length === 0 ? "none." : alternative);
    $("#recommendations").slideDown();
    return false;
  });

  //----------------------------------------
  //--- Sheep Recommendations
  //----------------------------------------
  $("#sheep_sizeCalc").submit(function () {
    //-- calculate
    emulsion = $("#sheep_emulsion").val();
    linkLength = $("#sheep_length").val();
    linksPerPound = $("#sheep_linksperlb").val();
    x = linkLength * linksPerPound;
    a = 25800 / x;
    targetCaseSize = Math.round(Math.sqrt(a));
    //-- find in the arrays
    var recommendation = "none.";
    var alternative = "none.";
    if (emulsion == "fine") {
      recommendation = $.map(sheepFineArray, function (n) {
        return targetCaseSize == n.size ? n.recommendation : null;
      });
      alternative = $.map(sheepFineArray, function (n) {
        return targetCaseSize == n.size ? n.alternative : null;
      });
    } else {
      recommendation = $.map(sheepCoarseArray, function (n) {
        return targetCaseSize == n.size ? n.recommendation : null;
      });
      alternative = $.map(sheepCoarseArray, function (n) {
        return targetCaseSize == n.size ? n.alternative : null;
      });
    }
    //-- display
    $("#recommendation").html(
      recommendation.length === 0 ? "none." : recommendation
    );
    $("#alternative").html(alternative.length === 0 ? "none." : alternative);
    $("#recommendations").slideDown();
    return false;
  });

  //----------------------------------------
  //--- Beef Recommendations
  //----------------------------------------
  $("#beef_sizeCalc").submit(function () {
    //-- calculate
    linkLength = $("#beef_length").val();
    linksPerPound = $("#beef_linksperlb").val();
    x = linkLength * linksPerPound;
    a = 25800 / x;
    targetCaseSize = Math.round(Math.sqrt(a));
    console.log(
      "linkLength: " +
        linkLength +
        ", linksPerPound: " +
        linksPerPound +
        ", x: " +
        x +
        ", a: " +
        a +
        ", targetCaseSize: " +
        targetCaseSize
    );
    var recommendation = "none.";
    var alternative = "none.";
    //-- find in the arrays
    recommendation = $.map(beefArray, function (n) {
      return targetCaseSize == n.size ? n.recommendation : null;
    });
    alternative = $.map(beefArray, function (n) {
      return targetCaseSize == n.size ? n.alternative : null;
    });
    //-- display
    $("#recommendation").html(
      recommendation.length === 0 ? "none." : recommendation
    );
    $("#alternative").html(alternative.length === 0 ? "none." : alternative);
    $("#recommendations").slideDown();
    return false;
  });

  //----------------------------------------
  //--- Collagen Recommendations
  //----------------------------------------
  $("#collagen_sizeCalc").submit(function (event) {
    //-- calculate
    type = $("#collagen_product").val();
    linkLength = $("#collage_length").val();
    linkLbs = $("#collagen_linksperlb").val();
    var recommendation = "none.";
    var alternative = "none.";
    //-- find in the arrays
    recommendation = $.map(collagenArray, function (n) {
      return type == n.type &&
        linkLength == n.linkLength &&
        linkLbs == n.linkLbs
        ? n.recommendation
        : null;
    });
    alternative = $.map(collagenArray, function (n) {
      return type == n.type &&
        linkLength == n.linkLength &&
        linkLbs == n.linkLbs
        ? n.alternative
        : null;
    });
    //-- display
    $("#recommendation").html(
      recommendation.length === 0 ? "none." : recommendation
    );
    $("#alternative").html(alternative.length === 0 ? "none." : alternative);
    $("#recommendations").slideDown();
    return false;
  });

  //----------------------------------------
  //--- Fibrous Recommendations
  //----------------------------------------
  $("#fibrous_sizeCalc").submit(function () {
    //-- calculate
    color = $("#fibrous_color").val();
    printing = $("#fibrous_printing").val();
    lbsperpiece = $("#fibrous_lbsperpiece").val();
    var recommendation = "none.";
    var alternative = "none.";
    //-- find in the arrays
    recommendation = $.map(fibrousArray, function (n) {
      return color == n.size &&
        printing == n.printing &&
        lbsperpiece == n.lbsperpiece
        ? n.recommendation
        : null;
    });
    alternative = $.map(fibrousArray, function (n) {
      return color == n.size &&
        printing == n.printing &&
        lbsperpiece == n.lbsperpiece
        ? n.alternative
        : null;
    });
    //-- display
    $("#recommendation").html(
      recommendation.length === 0 ? "none." : recommendation
    );
    $("#alternative").html(alternative.length === 0 ? "none." : alternative);
    $("#recommendations").slideDown();
    return false;
  });

  $(".sizeCalc").on(
    "keyup change paste",
    "input, select, textarea",
    function () {
      $("#recommendations").slideUp();
      $("#recommendation").html(null);
      $("#alternative").html(null);
    }
  );

  //----------------------------------------
  // Hog Array
  //----------------------------------------
  hogArray = [
    {
      size: "30",
      recommendation:
        '<a href="/products/hog-casings?variant=40228888248487">30/32 Whisker-Free Tubed Hog Casings</a>',
      alternative: "none.",
    },
    {
      size: "31",
      recommendation:
        '<a href="/products/hog-casings?variant=40228888248487">30/32 Whisker-Free Tubed Hog Casings</a>',
      alternative: "none.",
    },
    {
      size: "32",
      recommendation:
        '<ul><li><a href="/products/hog-casings?variant=40228888281255">32/35 Whisker-Free Tubed Hog Casings</a></li><li><a href="/products/hog-casings?variant=42595523133607">32/35 Whisker-Free Non-Tubed Hog Casings</a></li></ul>',
      alternative:
        '<a href="/products/hog-casings?variant=40228888248487">30/32 Whisker-Free Tubed Hog Casings</a>',
    },
    {
      size: "33",
      recommendation:
        '<ul><li><a href="/products/hog-casings?variant=40228888281255">32/35 Whisker-Free Tubed Hog Casings</a></li><li><a href="/products/hog-casings?variant=42595523133607">32/35 Whisker-Free Non-Tubed Hog Casings</a></li></ul>',
      alternative: "none.",
    },
    {
      size: "34",
      recommendation:
        '<ul><li><a href="/products/hog-casings?variant=40228888281255">32/35 Whisker-Free Tubed Hog Casings</a></li><li><a href="/products/hog-casings?variant=42595523133607">32/35 Whisker-Free Non-Tubed Hog Casings</a></li></ul>',
      alternative: "none.",
    },
    {
      size: "35",
      recommendation:
        '<ul><li><a href="/products/hog-casings?variant=40228888314023">35/38 Whisker-Free Tubed Hog Casings</a></li><li><a href="/products/hog-casings?variant=42595523166375">35/38 Whisker-Free Non-Tubed Hog Casings</a></li></ul>',
      alternative:
        '<ul><li><a href="/products/hog-casings?variant=40228888281255">32/35 Whisker-Free Tubed Hog Casings</a></li><li><a href="/products/hog-casings?variant=42595523133607">32/35 Whisker-Free Non-Tubed Hog Casings</a></li></ul>',
    },
    {
      size: "36",
      recommendation:
        '<ul><li><a href="/products/hog-casings?variant=40228888314023">35/38 Whisker-Free Tubed Hog Casings</a></li><li><a href="/products/hog-casings?variant=42595523166375">35/38 Whisker-Free Non-Tubed Hog Casings</a></li></ul>',
      alternative: "none.",
    },
    {
      size: "37",
      recommendation:
        '<ul><li><a href="/products/hog-casings?variant=40228888314023">35/38 Whisker-Free Tubed Hog Casings</a></li><li><a href="/products/hog-casings?variant=42595523166375">35/38 Whisker-Free Non-Tubed Hog Casings</a></li></ul>',
      alternative: "none.",
    },
    {
      size: "38",
      recommendation:
        '<a href="/products/hog-casings?variant=40228888346791">38/40 Whisker-Free Tubed Hog Casings</a>',
      alternative:
        '<a href="/products/hog-casings?variant=40228888314023">35/38 Whisker-Free Tubed Hog Casings</a>',
    },
    {
      size: "39",
      recommendation:
        '<a href="/products/hog-casings?variant=40228888346791">38/40 Whisker-Free Tubed Hog Casings</a>',
      alternative: "none.",
    },
    {
      size: "40",
      recommendation:
        '<a href="/products/hog-casings?variant=40228888379559">40/42 Whisker-Free Tubed Hog Casings</a>',
      alternative:
        '<a href="/products/hog-casings?variant=40228888346791">38/40 Whisker-Free Tubed Hog Casings</a>',
    },
    {
      size: "41",
      recommendation:
        '<a href="/products/hog-casings?variant=40228888379559">40/42 Whisker-Free Tubed Hog Casings</a>',
      alternative: "none.",
    },
    {
      size: "42",
      recommendation:
        '<a href="/products/hog-casings?variant=40228888379559">40/42 Whisker-Free Tubed Hog Casings</a>',
      alternative: "none.",
    },
  ];

  //----------------------------------------
  // Sheep Fine Array
  //----------------------------------------
  sheepFineArray = [
    {
      size: "20",
      recommendation:
        '<a href="/products/sheep-casings?variant=40228888674471">20/22 Fine Emulsion Tubed Sheep Casings</a>',
      alternative: "none.",
    },
    {
      size: "21",
      recommendation:
        '<a href="/products/sheep-casings?variant=40228888674471">20/22 Fine Emulsion Tubed Sheep Casings',
      alternative: "none.",
    },
    {
      size: "22",
      recommendation:
        '<a href="/products/sheep-casings?variant=40228888740007">22/24 Fine Emulsion Tubed Sheep Casings</a>',
      alternative:
        '<a href="/products/sheep-casings?variant=40228888674471">20/22 Fine Emulsion Tubed Sheep Casings</a>',
    },
    {
      size: "23",
      recommendation:
        '<a href="/products/sheep-casings?variant=40228888740007">22/24 Fine Emulsion Tubed Sheep Casings</a>',
      alternative: "none.",
    },
    {
      size: "24",
      recommendation:
        '<a href="/products/sheep-casings?variant=40228888805543">24/26 Fine Emulsion Tubed Sheep Casings</a>',
      alternative:
        '<a href="/products/sheep-casings?variant=40228888740007">22/24 Fine Emulsion Tubed Sheep Casings</a>',
    },
    {
      size: "25",
      recommendation:
        '<a href="/products/sheep-casings?variant=40228888805543">24/26 Fine Emulsion Tubed Sheep Casings</a>',
      alternative: "none.",
    },
    {
      size: "26",
      recommendation:
        '<a href="/products/sheep-casings?variant=40228888805543">24/26 Fine Emulsion Tubed Sheep Casings</a>',
      alternative: "none.",
    },
  ];

  //----------------------------------------
  // Sheep Coarse Array
  //----------------------------------------
  sheepCoarseArray = [
    {
      size: "20",
      recommendation:
        '<a href="/products/sheep-casings?variant=40228888707239">20/22 Coarse Emulsion Tubed Sheep Casings</a>',
      alternative: "none.",
    },
    {
      size: "21",
      recommendation:
        '<a href="/products/sheep-casings?variant=40228888707239">20/22 Coarse Emulsion Tubed Sheep Casings',
      alternative: "none.",
    },
    {
      size: "22",
      recommendation:
        '<a href="/products/sheep-casings?variant=40228888772775">22/24 Coarse Emulsion Tubed Sheep Casings</a>',
      alternative:
        '<a href="/products/sheep-casings?variant=40228888707239">20/22 Coarse Emulsion Tubed Sheep Casings</a>',
    },
    {
      size: "23",
      recommendation:
        '<a href="/products/sheep-casings?variant=40228888772775">22/24 Coarse Emulsion Tubed Sheep Casings</a>',
      alternative: "none.",
    },
    {
      size: "24",
      recommendation:
        '<a href="/products/sheep-casings?variant=40228888838311">24/26 Coarse Emulsion Tubed Sheep Casings</a>',
      alternative:
        '<a href="/products/sheep-casings?variant=40228888772775">22/24 Coarse Emulsion Tubed Sheep Casings</a>',
    },
    {
      size: "25",
      recommendation:
        '<a href="/products/sheep-casings?variant=40228888838311">24/26 Coarse Emulsion Tubed Sheep Casings</a>',
      alternative: "none.",
    },
    {
      size: "26",
      recommendation:
        '<a href="/products/sheep-casings?variant=40228888838311">24/26 Coarse Emulsion Tubed Sheep Casings</a>',
      alternative: "none.",
    },
  ];

  //----------------------------------------
  // Beef Array
  //----------------------------------------
  beefArray = [
    {
      size: "38",
      recommendation:
        '<a href="products/beef-casings?variant=45471182848167">38/40 Beef Rounds</a>',
      alternative: "none.",
    },
    {
      size: "39",
      recommendation:
        '<a href="products/beef-casings?variant=45471182848167">38/40 Beef Rounds</a>',
      alternative: "none.",
    },
    {
      size: "40",
      recommendation:
        '<a href="/products/beef-casings?variant=45471182880935">40/43 Beef Rounds</a>',
      alternative:
        '<a href="products/beef-casings?variant=45471182848167">38/40 Beef Rounds</a>',
    },
    {
      size: "41",
      recommendation:
        '<a href="/products/beef-casings?variant=45471182880935">40/43 Beef Rounds</a>',
      alternative: "none.",
    },
    {
      size: "42",
      recommendation:
        '<a href="/products/beef-casings?variant=45471182880935">40/43 Beef Rounds</a>',
      alternative: "none.",
    },
    {
      size: "43",
      recommendation:
        '<a href="/products/beef-casings?variant=45471182880935">40/43 Beef Rounds</a>',
      alternative: "none.",
    },
    {
      size: "50",
      recommendation:
        '<a href="/products/beef-casings?variant=45471182946471">50/55 Beef Middles</a>',
      alternative: "none.",
    },
    {
      size: "51",
      recommendation:
        '<a href="/products/beef-casings?variant=45471182946471">50/55 Beef Middles</a>',
      alternative: "none.",
    },
    {
      size: "52",
      recommendation:
        '<a href="/products/beef-casings?variant=45471182946471">50/55 Beef Middles</a>',
      alternative: "none.",
    },
    {
      size: "53",
      recommendation:
        '<a href="/products/beef-casings?variant=45471182946471">50/55 Beef Middles</a>',
      alternative: "none.",
    },
    {
      size: "54",
      recommendation:
        '<a href="/products/beef-casings?variant=45471182946471">50/55 Beef Middles</a>',
      alternative: "none.",
    },
    {
      size: "55",
      recommendation:
        '<a href="/products/beef-casings?variant=45471182946471">50/55 Beef Middles</a>',
      alternative: "none.",
    },
  ];

  //----------------------------------------
  // Collagen Array
  //----------------------------------------
  collagenArray = [
    {
      type: "fresh",
      linkLength: "4",
      linkLbs: "15",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228889002151">21mm x 50ft clear collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "fresh",
      linkLength: "4",
      linkLbs: "3",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228889034919">32mm x 35ft clear collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "fresh",
      linkLength: "6",
      linkLbs: "10",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228889002151">21mm x 50ft clear collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "fresh",
      linkLength: "6",
      linkLbs: "2",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228889034919">32mm x 35ft clear collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "fresh",
      linkLength: "8",
      linkLbs: "7",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228889002151">21mm x 50ft clear collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "fresh",
      linkLength: "8",
      linkLbs: "2",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228889034919">32mm x 35ft clear collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "fresh",
      linkLength: "10",
      linkLbs: "6",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228889002151">21mm x 50ft clear collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "fresh",
      linkLength: "10",
      linkLbs: "1",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228889034919">32mm x 35ft clear collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "fresh",
      linkLength: "12",
      linkLbs: "5",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228889002151">21mm x 50ft clear collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "fresh",
      linkLength: "12",
      linkLbs: "1",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228889034919">32mm x 35ft clear collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "snack",
      linkLength: "4",
      linkLbs: "17",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228888969383">18mm x 50ft mahogany collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "snack",
      linkLength: "4",
      linkLbs: "15",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228889067687">19mm x 61ft mahogany collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "snack",
      linkLength: "4",
      linkLbs: "14",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228888936615">21mm x 51ft mahogany collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "snack",
      linkLength: "6",
      linkLbs: "12",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228888969383">18mm x 50ft mahogany collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "snack",
      linkLength: "6",
      linkLbs: "10",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228889067687">19mm x 61ft mahogany collagen casings</a>',
      alternative:
        '<a href="/products/collagen-casings?variant=40228888936615">21mm x 51ft mahogany collagen casings</a>',
    },
    {
      type: "snack",
      linkLength: "8",
      linkLbs: "9",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228888969383">18mm x 50ft mahogany collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "snack",
      linkLength: "8",
      linkLbs: "8",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228889067687">19mm x 61ft mahogany collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "snack",
      linkLength: "8",
      linkLbs: "7",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228888936615">21mm x 51ft mahogany collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "snack",
      linkLength: "10",
      linkLbs: "7",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228888969383">18mm x 50ft mahogany collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "snack",
      linkLength: "10",
      linkLbs: "6",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228889067687">19mm x 61ft mahogany collagen casings</a>',
      alternative:
        '<a href="/products/collagen-casings?variant=40228888936615">21mm x 51ft mahogany collagen casings</a>',
    },
    {
      type: "snack",
      linkLength: "12",
      linkLbs: "6",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228888969383">18mm x 50ft mahogany collagen casings</a>',
      alternative: "none.",
    },
    {
      type: "snack",
      linkLength: "12",
      linkLbs: "5",
      recommendation:
        '<a href="/products/collagen-casings?variant=40228889067687">19mm x 61ft mahogany collagen casings</a>',
      alternative:
        '<a href="/products/collagen-casings?variant=40228888936615">21mm x 51ft mahogany collagen casings</a>',
    },
  ];

  //----------------------------------------
  // Fibrous Array
  //----------------------------------------
  fibrousArray = [
    {
      print: "Venison Not For Sale",
      color: "Clear",
      lbsperpiece: "4.6",
      recommendation:
        '<a href="/products/fibrous-casings?variant=40265161769127">2-1/2x20 printed fibrous casings</a>',
      alternative: "none.",
    },
    {
      print: "None",
      color: "Clear",
      lbsperpiece: "4.6",
      recommendation:
        '<a href="/products/fibrous-casings?variant=40265161834663">2-1/2x20 clear fibrous casings</a>',
      alternative: "none.",
    },
    {
      print: "None",
      color: "Clear",
      lbsperpiece: "5.6",
      recommendation:
        '<a href="/products/fibrous-casings?variant=40265161867431">2-1/2x24 clear fibrous casings</a>',
      alternative: "none.",
    },
    {
      print: "None",
      color: "Mohagany",
      lbsperpiece: "1.5",
      recommendation:
        '<a href="/products/fibrous-casings?variant=40265161900199">1-1/2x12 mohagany fibrous casings</a>',
      alternative: "none.",
    },
    {
      print: "None",
      color: "Mohagany",
      lbsperpiece: "2.75",
      recommendation:
        '<a href="/products/fibrous-casings?variant=40265161965735">1-1/2x20 mohagany fibrous casings</a>',
      alternative: "none.",
    },
    {
      print: "None",
      color: "Mohagany",
      lbsperpiece: "4.6",
      recommendation:
        '<a href="/products/fibrous-casings?variant=40265161998503">2-1/2x20 mohagany fibrous casings</a>',
      alternative: "none.",
    },
    {
      print: "None",
      color: "Mohagany",
      lbsperpiece: "5.6",
      recommendation:
        '<a href="/products/fibrous-casings?variant=40265161638055">2-1/2x24 mohagany fibrous casings</a>',
      alternative: "none.",
    },
  ];

  var ccpaSlideUpAll = function () {
    $("#form-ccpa-edit-account-request").slideUp(100);
    $("#form-ccpa-data-account-request").slideUp(100);
    $("#form-ccpa-personal-data-report-request").slideUp(100);
    $("#form-ccpa-delete-account-request").slideUp(100);
    $("#form-ccpa-do-not-sell-request").slideUp(100);
    $("#ccpa_page button").attr("aria-expanded", "false");
  };

  var email,
    type,
    consentGiven = false;
  var verificationModalContent =
    '<div id="data-verification-background"><div class="loading"></div><div id="data-verification-modal"><span class="data-verification-close">&times;</span><div id="data-verification-container"><input type="checkbox" style="display: none;"><label id="data-verification-icon"><svg width="18px" height="18px" viewBox="0 0 18 18"><path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path></path><polyline points="1 9 7 14 15 4"></polyline></svg></label><p>I give my consent on collecting my email and IP address for the purpose of processing this request. For more check <a href="https://gdprcdn.b-cdn.net/pages/privacy_policy"  target="_blank">Privacy Policy</a>.</p></div></div></div>';

  var ccpaSendRequest = function (callback) {
    $.ajax({
      url: "https://www.cloudflare.com/cdn-cgi/trace",
      method: "GET",
      success: function (resp) {
        if (!resp.error) {
          let ipInfo = resp;
          let ipRegex = /[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}/;
          let ipAddress = ipInfo.match(ipRegex)[0];

          $.ajax({
            url: "https://gdpr.apps.isenselabs.com/gdprRequests/submitRequest",
            method: "POST",
            data: {
              shop: Shopify.shop,
              email: email,
              type: type,
              sourceOfRequest: 2,
              ipAddress: ipAddress,
              consentGiven: consentGiven,
              lang: Shopify.locale ? Shopify.locale : "",
              gtranslateLang: isenseGDPR.Cookies.get("googtrans")
                ? isenseGDPR.Cookies.get("googtrans")
                : "",
            },
            success: function (resp) {
              if (!resp.error) {
                ccpaSlideUpAll();
                alert(
                  "Your request has been submitted successfully. Please check your email for more information."
                );
              } else {
                alert(resp.message);
              }
              if (typeof callback == "function") {
                callback(resp);
              }
            },
          });
        } else {
          alert(resp.message);
        }
      },
    });
  };

  $(document).ready(function () {
    let searchParams = new URLSearchParams(window.location.search);
    let param = searchParams.get("id");
    if (param) {
      document.getElementById(param).scrollIntoView();
    }

    //Append modal to body, because otherwise it will not stay centered(even if position is fixed)
    $("body").append(verificationModalContent);

    // When the user clicks on <span> (x), close the modal
    $(".data-verification-close:first").on("click", function (e) {
      e.preventDefault();
      closeVerificationModal();
    });

    $("#data-verification-icon, #data-verification-container p").on(
      "click",
      function (e) {
        e.preventDefault();

        // Detect a href's click, because it is overwritten.
        if ($(e.target).is("a")) {
          window.open(e.target.href, "_blank");
          return;
        }

        $("#data-verification-icon").addClass("clicked");
        setTimeout(() => {
          $("#data-verification-modal").fadeOut();
          $("#data-verification-background .loading").css(
            "display",
            "inline-block"
          );
          consentGiven = true;
          ccpaSendRequest(function (resp) {
            consentGiven = false;
            closeVerificationModal();
          });
        }, 400);
      }
    );
  });

  function openVerificationModal() {
    $("#data-verification-modal").css("display", "block");
    $("#data-verification-background").css("display", "block");
  }
  function closeVerificationModal() {
    $("#data-verification-background").fadeOut();
    $("#data-verification-icon").removeClass("clicked");
    $("#data-verification-background .loading").css("display", "none");
  }

  $("#btn-ccpa-edit-account-request").on("click", function (e) {
    e.preventDefault();
    ccpaSlideUpAll();
    $("#form-ccpa-edit-account-request").slideDown(200);
    $(this).attr("aria-expanded", "true");
  });

  $("#form-ccpa-edit-account-request form input[type=submit]").on(
    "click",
    function (e) {
      e.preventDefault();
      email = $("#form-ccpa-edit-account-request form input[name=email]").val();
      type = "customer/edit";
      openVerificationModal();
    }
  );

  $(
    "#btn-ccpa-requests-request, #btn-ccpa-personal-information-request, #btn-ccpa-orders-request"
  ).on("click", function (e) {
    e.preventDefault();
    ccpaSlideUpAll();

    type = "";

    switch ($(this).attr("id")) {
      case "btn-ccpa-requests-request":
        type = "customer/requests";
        break;
      case "btn-ccpa-personal-information-request":
        type = "customer/personal_info";
        break;
      case "btn-ccpa-orders-request":
        type = "customer/orders";
        break;
    }

    $('#form-ccpa-data-account-request form input[name="request_type"]').val(
      type
    );

    $("#form-ccpa-data-account-request").slideDown(200);
    $(this).attr("aria-expanded", "true");
  });

  $("#form-ccpa-data-account-request form input[type=submit]").on(
    "click",
    function (e) {
      e.preventDefault();
      email = $("#form-ccpa-data-account-request form input[name=email]").val();
      type = $(
        '#form-ccpa-data-account-request form input[name="request_type"]'
      ).val();
      openVerificationModal();
    }
  );

  $("#btn-ccpa-personal-data-report-request").on("click", function (e) {
    e.preventDefault();
    ccpaSlideUpAll();
    $("#form-ccpa-personal-data-report-request").slideDown(200);
    $(this).attr("aria-expanded", "true");
  });

  $("#form-ccpa-personal-data-report-request form input[type=submit]").on(
    "click",
    function (e) {
      e.preventDefault();
      email = $(
        "#form-ccpa-personal-data-report-request form input[name=email]"
      ).val();
      type = "customer/report";
      openVerificationModal();
    }
  );

  $("#btn-ccpa-do-not-sell-request").on("click", function (e) {
    e.preventDefault();
    ccpaSlideUpAll();
    $("#form-ccpa-do-not-sell-request").slideDown(200);
    $(this).attr("aria-expanded", "true");
  });

  $("#form-ccpa-do-not-sell-request form input[type=submit]").on(
    "click",
    function (e) {
      e.preventDefault();
      email = $("#form-ccpa-do-not-sell-request form input[name=email]").val();
      type = "customer/do-not-sell";
      openVerificationModal();
    }
  );

  $("#btn-ccpa-delete-account-request").on("click", function (e) {
    e.preventDefault();
    ccpaSlideUpAll();
    $("#form-ccpa-delete-account-request").slideDown(200);
    $(this).attr("aria-expanded", "true");
  });

  $("#form-ccpa-delete-account-request form input[type=submit]").on(
    "click",
    function (e) {
      e.preventDefault();
      email = $(
        "#form-ccpa-delete-account-request form input[name=email]"
      ).val();
      type = "customer/delete";
      openVerificationModal();
    }
  );

  $("#btn-modal-close").on("click", function (e) {
    e.preventDefault();
    $(".additional-checkout-buttons").hide();
    $("input.checkout").hide();
    $("#modal").hide();
  });

  // Collections tabs - Add to cart functionality
  document.addEventListener('click', async function(e) {
    if (!e.target.classList.contains('add-to-cart-btn')) return;
    
    e.preventDefault();
    const button = e.target;
    const productCard = button.closest('.product-card') || 
                        button.closest('.recommended-product-item') ||
                        button.closest('article');
    
    if (!productCard) {
      console.error('Product card not found');
      return;
    }
    
    // Get variant ID
    let variantId;
    const variantSelector = productCard.querySelector('.variant-selector');
    const hiddenVariantInput = productCard.querySelector('.variant-id');
    
    if (variantSelector) {
      // Multiple variants - get selected option
      variantId = variantSelector.value;
    } else if (hiddenVariantInput) {
      // Single variant - get from hidden input
      variantId = hiddenVariantInput.value;
    }
    
    if (!variantId) {
      console.error('No variant ID found');
      return;
    }
    
    // Disable button and show loading state
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });
      
      if (response.ok) {
        // Get updated cart data
        const cartData = await fetch('/cart.js').then(r => r.json());
        
        // Determine source based on context
        const isRecommendation = productCard.classList.contains('recommended-product-item');
        const source = isRecommendation ? 'recommendations' : 'collections-tabs';
        
        // Publish cart update event if available
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: source,
            cartData: cartData,
            variantId: variantId
          });
        }
        
        // Open cart drawer
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.refreshAndOpen === 'function') {
          cartDrawer.refreshAndOpen();
        }
        
        // If it's a recommendation, remove the product item
        if (isRecommendation) {
          productCard.remove();
          
          // Check if there are any recommendations left
          const remainingItems = document.querySelectorAll('.recommended-product-item');
          if (remainingItems.length === 0) {
            const section = document.getElementById('cart-recommendations');
            if (section) section.style.display = 'none';
          }
        } else {
          // Show success feedback for collection tabs
          button.textContent = 'Added!';
          button.classList.add('added');
          
          // Reset button after 2 seconds
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
            button.classList.remove('added');
          }, 2000);
        }
        
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      button.textContent = 'Error';
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    }
  });

  // Update price when variant changes in collections tabs and recommendations
  document.addEventListener('change', function(e) {
    if (!e.target.classList.contains('variant-selector')) return;
    
    const selector = e.target;
    const productCard = selector.closest('.product-card') || 
                        selector.closest('.recommended-product-item') ||
                        selector.closest('article');
    
    if (!productCard) return;
    
    const selectedOption = selector.options[selector.selectedIndex];
    const newPrice = selectedOption.dataset.price;
    const variantId = selectedOption.value;
    const priceElement = productCard.querySelector('.product-details__price span') || 
                         productCard.querySelector('.recommended-product-price');
    
    if (priceElement && newPrice) {
      priceElement.textContent = newPrice;
    }
    
    // Update all product links to point to the selected variant
    const productLinks = productCard.querySelectorAll('.product-link');
    productLinks.forEach(function(link) {
      const currentUrl = link.getAttribute('href');
      if (currentUrl) {
        // Remove existing variant parameter if present
        const baseUrl = currentUrl.split('?')[0];
        // Add new variant parameter
        link.setAttribute('href', baseUrl + '?variant=' + variantId);
      }
    });
  });

})(jQuery);
